import { api } from 'roadie-ui'
import * as mainApi from 'util/server/mainApi'
import {
  deserializeConsolidationCompliance,
  deserializeConsolidationDetail,
} from 'viewModels/consolidationDetails/consolidation'
import { deserializeGigDetails } from 'viewModels/gigDetails'

export function fetchConsolidationDetailsBulk(cids) {
  return api.get(`/consolidations/details?ids=${cids.join(',')}`).then((resp) => {
    return resp.data
  })
}

function fetchConsolidationDetails_orFromGigIdFormat(cid) {
  return mainApi.getConsolidationDetails(cid)
}

function fetchConsolidationComplianceData(cid) {
  return mainApi.getConsolidationCompliance(cid)
}

export function fetchConsolidationDetails(cid) {
  return async (dispatch) => {
    try {
      const [consolidationDetailApiResponse, consolidationComplianceApiResponse] = await Promise.all([
        fetchConsolidationDetails_orFromGigIdFormat(cid),
        fetchConsolidationComplianceData(cid),
      ])

      const consolidation = await deserializeConsolidationDetail(consolidationDetailApiResponse)
      const complianceData = deserializeConsolidationCompliance(consolidationComplianceApiResponse)

      const gigIds = consolidation.gigs.map((g) => g.id)
      const gigDetailsApiResponse = await mainApi.getGigsDetails(gigIds)
      const gigs = deserializeGigDetails(gigDetailsApiResponse)

      return { consolidation, gigs, complianceData }
    } catch {
      dispatch({
        type: 'PUSH_FLASH',
        flash: {
          type: 'error',
          messageKey: 'dweb_flash_delivery_loading_problem',
        },
      })
    }
  }
}
